import type { ReactNode } from 'react';
import MgoCard from '@humanforce/mango-ui/dist/react/card/index.js';
import { asMangoElement } from './mango';

const MangoCard = asMangoElement(MgoCard);

interface CardProps {
  children: ReactNode;
  footer?: ReactNode;
  header?: ReactNode;
  className?: string;
}

export const Card = ({ children, footer, header, className }: CardProps) => {
  return (
    <MangoCard className={className}>
      {header && <div slot="header">{header}</div>}
      {children}
      {footer && <div slot="footer">{footer}</div>}
    </MangoCard>
  );
}
